import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'group'
})
export class GroupPipe implements PipeTransform {

  transform(groups: any, kitGroups?: any): any {
    return groups.filter(group => {
      const index = kitGroups.findIndex(kitGroup => {
        return group.id === kitGroup.id;
      });

      if (index > -1) {
        return false;
      } else {
        return true;
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/group.pipe.ts